// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"902153f4","239":"88b69e33","408":"d03fff47","455":"83f6059f","488":"6284d17b","783":"f538a482","977":"d973994f"}[chunkId] + ".chunk.js";
};